// src/pages/orders/components/shared/DeliveryChargeWeightSection.jsx
// Extracted from OrderSummarySection.jsx's weight + delivery-charge rows (Stage 8) so it can be
// reused verbatim by the offline-sales courier-fulfilled order form.
import React from 'react';
import { DollarSign, Truck, Loader2, Lock, Scale } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import { formatCurrency } from '../../../../utils/orderCalculations';
import styles from '../OrderSummarySection.module.css';

const DeliveryChargeWeightSection = ({
  weight,
  onWeightChange,
  deliveryCharge,
  onDeliveryChargeChange,
  isCalculatingDelivery,
  canChangeDeliveryCharge,
  hideDeliveryChargeRow = false,
}) => {
  const { t } = useLocalization();

  const formatNumberForDisplay = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return num.toString();
  };

  const handleWeightChange = (value) => {
    if (value === '' || value === null || value === undefined) {
      onWeightChange(1);
      return;
    }
    const stringValue = value.toString();
    if (stringValue.endsWith('.') || stringValue.endsWith('.0')) return;
    const numValue = parseFloat(stringValue);
    if (!isNaN(numValue)) onWeightChange(numValue);
  };

  const handleDeliveryChargeChange = (value) => {
    if (value === '' || value === null || value === undefined) {
      onDeliveryChargeChange(0);
      return;
    }
    const stringValue = value.toString();
    if (stringValue.endsWith('.') || stringValue.endsWith('.0')) return;
    const numValue = parseFloat(stringValue);
    if (!isNaN(numValue)) {
      onDeliveryChargeChange(numValue);
    }
  };

  return (
    <>
      {/* Weight */}
      <div className={styles.summaryRow}>
        <span className={styles.rowLabel}>
          <Scale size={13} className={styles.rowIcon} />
          {t('ecomOrders.weightKg')}
        </span>
        <span className={styles.rowValue}>
          <div className={styles.editableDelivery}>
            <input
              type="text"
              value={formatNumberForDisplay(weight)}
              onChange={(e) => handleWeightChange(e.target.value)}
              className={styles.deliveryInput}
            />
            <span className={styles.weightUnit}>kg</span>
          </div>
        </span>
      </div>

      {/* Delivery Charge */}
      {!hideDeliveryChargeRow && (
        <div className={styles.summaryRow}>
          <span className={styles.rowLabel}>
            <Truck size={13} className={styles.rowIcon} />
            {t('ecomOrders.deliveryCharge')}
            {isCalculatingDelivery && <Loader2 size={12} className={styles.calcIcon} />}
          </span>
          <span className={styles.rowValue}>
            {canChangeDeliveryCharge && !isCalculatingDelivery ? (
              <div className={styles.editableDelivery}>
                <DollarSign size={12} className={styles.currencyIcon} />
                <input
                  type="text"
                  value={formatNumberForDisplay(deliveryCharge)}
                  onChange={(e) => handleDeliveryChargeChange(e.target.value)}
                  className={styles.deliveryInput}
                />
              </div>
            ) : (
              <span className={styles.deliveryValue}>
                {formatCurrency(deliveryCharge)}
                {!canChangeDeliveryCharge && <Lock size={11} className={styles.lockIcon} />}
              </span>
            )}
          </span>
        </div>
      )}
    </>
  );
};

export default DeliveryChargeWeightSection;
